import _ from "lodash";

const convictions = {
    AC10: _.range(5, 10),
    AC20: _.range(5, 10),
    AC30: _.range(4, 9),
    BA10: [6],
    BA30: [6],
    BA40: _.range(3, 11),
    BA60: _.range(3, 11),
    CD10: _.range(3, 9),
    CD20: _.range(3, 9),
    CD30: _.range(3, 9),
    CD40: _.range(3, 11),
    CD50: _.range(3, 11),
    CD60: _.range(3, 11),
    CD70: _.range(3, 11),
    CD80: _.range(3, 11),
    CD90: _.range(3, 11),
    CU10: [3],
    CU20: [3],
    CU30: [3],
    CU40: [3],
    CU50: [3],
    CU80: _.range(3, 6),
    DD10: _.range(3, 11),
    DD40: _.range(3, 11),
    DD60: _.range(3, 11),
    DD80: _.range(3, 11),
    DD90: _.range(3, 9),
    DR10: _.range(3, 11),
    DR20: _.range(3, 11),
    DR30: _.range(3, 11),
    DR31: _.range(3, 11),
    DR40: [10],
    DR50: [10],
    DR60: [10],
    DR61: [10],
    DR70: [4],
    DG10: _.range(3, 11),
    DG40: [10],
    DG60: _.range(3, 11),
    DR80: _.range(3, 11),
    DR90: [10],
    IN10: _.range(6, 8),
    LC20: _.range(3, 6),
    LC30: _.range(3, 6),
    LC40: _.range(3, 6),
    LC50: _.range(3, 6),
    MS10: [3],
    MS20: [3],
    MS30: [2],
    MS50: _.range(3, 11),
    MS60: [3],
    MS70: [3],
    MS80: [3],
    MS90: [6],
    MW10: [3],
    PC10: [3],
    PC20: [3],
    PC30: [3],
    SP10: _.range(3, 6),
    SP20: _.range(3, 6),
    SP30: _.range(3, 6),
    SP40: _.range(3, 6),
    SP50: _.range(3, 6),
    TS10: [3],
    TS20: [3],
    TS30: [3],
    TS40: [3],
    TS50: [3],
    TS60: [3],
    TS70: [3],
    TT99: [12],
    UT50: _.range(3, 11),
};

export const getPointsFromConviction = type => {
    return (convictions[type] ? convictions[type] : _.range(0, 12)).map(p => ({key: p, value: p}));
};

